import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-edd10386"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "section-title" }
const _hoisted_3 = { class: "verification-code-btn-wrapper" }

import { reactive, watch, computed, ref } from 'vue';
  import { FormItem } from '@/types/form';
  import { ColorVariants } from '@/constants';
  import { useI18n } from 'vue-i18n';
  import { useToast } from 'bootstrap-vue-3';
  import { authStore } from '@/stores';
  import _ from 'lodash';

  export interface IProps {
    form: Form,
    type: 'password' | 'email'
  }

  export type Form = {
    [propName: string]: any;
  }

  export type SubmitData = {
    form: Form,
    type: IProps['type']
  }

  interface IEmits {
    (event: 'submit', data: SubmitData) : void;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    form: null,
    type: null
  },
  emits: ["submit"],
  setup(__props: any, { emit: emits }: { emit: ({
    (event: 'submit', data: SubmitData) : void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    form: Form,
    type: 'password' | 'email'
  }

  const { t, locale } = useI18n();
  const toast = useToast();
  
  
  const originEmail = ref();
  const newForm = reactive<Form>(props.form);

  const disabled = computed(() => {
    // 已验证 - 未修改邮箱，禁止用户提交（这个提交没有意义）
    // 已验证 - 修改了邮箱，提交需要新邮箱，密码，验证码（走的是修改邮箱流程）
    // 未验证 - 未修改邮箱，只需要提交验证码。（走的是验证邮箱流程）
    // 未验证 - 修改了邮箱 - 同 已验证 - 修改了邮箱（走的是修改邮箱流程
    if (props.type !== 'email') {
      return false;
    }
    if (originEmail.value !== newForm.email) {
      return false;
    }
    return _.get(authStore.user, 'profile.email_verified');
  });

  const accountInformationFormItems = computed<FormItem[]>(() => {
    if (props.type === 'email') {
      const emailChange = originEmail.value !== newForm.email;
      const emailVerified = _.get(authStore.user, 'profile.email_verified');
      const emailConfig: FormItem = {
        label: t('EMAIL ADDRESS'),
        type: 'input',
        inputType: 'email',
        key: 'email',
        required: true,
        placeholder: 'address@domain.com',
      };
      if (!emailVerified) {
        emailConfig.slots = {
          description: {
            template: `<div style="color: red;">${t('Email not verified')}</div>`
          }
        };
      }
      return [
        emailConfig,
        emailChange && {
          label: t('PASSWORD'),
          type: 'input',
          inputType: 'password',
          // 避免和密码联动 提交的时候替换成password
          key: 'emailPassword',
          required: true,
          placeholder: '',
          triggerPwd: true
        },
        (emailChange || !emailVerified) && {
          slots: {
            label: { template: `${t('VERIFICATION CODE')}${locale.value === 'ja' ? '<span style="opacity: 0.6;">（上記 アドレス に 届い た 認証 コード を 入力 し て ください）</span>' : ''}` }
          },
          type: 'input',
          key: 'verification_code',
          required: true,
          placeholder: ''
        }
      ].filter(Boolean) as FormItem[];
    }
    return [
      {
        label: t('CURRENT_PASSWORD'),
        type: 'input',
        inputType: 'password',
        key: 'current_password',
        required: true,
        placeholder: '',
        triggerPwd: true
      },
      {
        label: t('PASSWORD'),
        type: 'input',
        inputType: 'password',
        key: 'password',
        required: true,
        placeholder: '',
        triggerPwd: true
      },
      {
        label: t('CONFIRM PASSWORD'),
        type: 'input',
        inputType: 'password',
        key: 'password_confirmation',
        required: true,
        placeholder: '',
        triggerPwd: true
      }
    ];
  });

  function formItemChange(data: any) {
    newForm[data.key] = data.value;
  }

  function handleSubmit() {
    const formKeys: string[] = [];
    // 由于表单动态，key值校验也需要动态
    accountInformationFormItems.value.forEach((item) => {
      formKeys.push(item.key);
    });
    const params: Form = {};
    Object.keys(newForm).forEach(key => {
      // 剔除不要的字段
      if (!formKeys.includes(key)) {
        return;
      }
      if (newForm[key]) {
        params[key] = newForm[key];
      }
    });
    // 邮箱操作，并且有输入密码的操作，进行key的交换
    if (props.type === 'email' && params['emailPassword']) {
      params['password'] = params['emailPassword'];
      delete params.emailPassword;
    }

    if (props.type === 'password' && params.password !== params.password_confirmation) {
      toast.show({ title: t('Tips'), body: t('Inconsistent password input') }, { variant: 'warning' });
      return;
    }
    emits('submit', { form: params, type: props.type });
  }

  watch(props.form, () => {
    if (props.type === 'email' && !originEmail.value && props.form.email) {
      originEmail.value = props.form.email;
    }
    Object.assign(newForm, props.form || {});
  });


return (_ctx: any,_cache: any) => {
  const _component_AppFormGroupItem = _resolveComponent("AppFormGroupItem")!
  const _component_AppVerificationCodeBtn = _resolveComponent("AppVerificationCodeBtn")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_form = _resolveComponent("b-form")!

  return (_openBlock(), _createBlock(_component_b_form, {
    class: "edit-component",
    onSubmit: handleSubmit
  }, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("h4", _hoisted_2, _toDisplayString(__props.type === 'email' ? _unref(t)('Email information') : _unref(t)('Password information')), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(accountInformationFormItems), (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.key
          }, [
            _createVNode(_component_AppFormGroupItem, {
              config: item,
              form: _unref(newForm),
              onChange: formItemChange
            }, null, 8, ["config", "form"]),
            _createElementVNode("div", _hoisted_3, [
              (item.key === 'email' && __props.type === 'email')
                ? (_openBlock(), _createBlock(_component_AppVerificationCodeBtn, {
                    key: 0,
                    target: _unref(newForm).email,
                    insert: "half",
                    "target-type": "email",
                    event: "verify_email",
                    "show-count-down": false
                  }, null, 8, ["target"]))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128))
      ]),
      _createVNode(_component_b_button, {
        type: "submit",
        pill: "",
        variant: _unref(ColorVariants).primary,
        disabled: _unref(disabled),
        class: "btn-submit"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(!_ctx.$get(_unref(authStore).user, 'profile.email_verified') ? _unref(t)('Verified') : _unref(t)('Save')), 1)
        ]),
        _: 1
      }, 8, ["variant", "disabled"])
    ]),
    _: 1
  }))
}
}

})